import Styles from './TikTokPost.module.scss'
import { Skin } from '../Skin'
import { SkinProps } from '../Types'

const TikTokPost = ({ children, maxCharacterCount }: SkinProps) => {
  return (
    <Skin.Root className={Styles.tikTokPost} data-testid="tiktok-frame-skin">
      {children}
      <Skin.CaptionBelow lines={3} maxCharacterCount={maxCharacterCount} />
    </Skin.Root>
  )
}

export { TikTokPost }
